import { render, staticRenderFns } from "./TitleBadge.vue?vue&type=template&id=641c1152&scoped=true&"
import script from "./TitleBadge.vue?vue&type=script&lang=js&"
export * from "./TitleBadge.vue?vue&type=script&lang=js&"
import style0 from "./TitleBadge.vue?vue&type=style&index=0&id=641c1152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c1152",
  null
  
)

export default component.exports